import { useState } from "react";
import { Box, Typography } from "@mui/material";

const options = [
  { id: "OR", label: "OR" },
  { id: "AND", label: "AND" },
];

export default function AudienceLogicPillToggle({
  editState,
  audienceData,
  formikProps,
}) {
  const handleSelect = (id) => {
    formikProps.setValues((prev) => ({
      ...prev,
      audienceMeta: {
        ...prev.audienceMeta,
        [audienceData.audience_id]: id,
      },
    }));
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        bgcolor: "#1048dd17",
        borderRadius: "999px",
        p: "4px",
        position: "relative",
      }}
    >
      {options.map(({ id, label }) => {
        const isSelected =
          formikProps.values?.audienceMeta[audienceData.audience_id] === id;
        return (
          <Box
            key={id}
            onClick={() => handleSelect(id)}
            sx={{
              pointerEvents: !editState && "none",
              position: "relative",
              zIndex: 1,
              px: 3.5,
              py: "7px",
              borderRadius: "999px",
              cursor: "pointer",
              bgcolor: isSelected ? "#fff" : "transparent",
              boxShadow: isSelected ? "0 1px 6px rgba(0,0,0,0.12)" : "none",
              transition: "background 0.2s, box-shadow 0.2s",
              userSelect: "none",
            }}
          >
            <Typography
              variant="body2"
              fontWeight={600}
              sx={{
                fontSize: 13,

                letterSpacing: "0.03em",
                color: isSelected ? "primary.dark" : "text.secondary",
                transition: "color 0.2s",
              }}
            >
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
